<div class="cookies">
  <div class="shadow"></div>

  <div class="video">
    <video loop autoplay #videoBackground [muted]="true">
      <source src="https://d2z7yiz3wla4oq.cloudfront.net/videos/ride-run.mp4" type="video/mp4" />
      Sorry, your browser doesn't support embedded videos.
    </video>
  </div>

  <div class="cookieSelector">
    <div class="bloc">
      <div class="bloc-inner">
        <div class="content">
          <p class="subTitle">{{ 'cookie.functionnal.title' | translate }}</p>
          <p class="text">{{ 'cookie.functionnal.text' | translate }}</p>
        </div>
        <div class="btn-list">
          <button class="btn-primary" disabled><em class="fa fa-check"></em>&nbsp;{{ 'cookie.required' | translate}}</button>
        </div>
      </div>
      <hr />
      <div class="bloc-inner">
        <div class="content">
          <p class="subTitle">{{ 'cookie.audience.title' | translate }}</p>
          <p class="text">{{ 'cookie.audience.text' | translate }}</p>
        </div>
        <div class="btn-list">

          <button
          [ngClass]="cookieConsent === 'deny' ? 'btn-primary' : 'btn-primary-unselected'"
          [disabled]="cookieConsent === 'deny'"
          (click)="cookieService.set('deny')">
            <em *ngIf="cookieConsent === 'deny'" class="fa fa-check">&nbsp;</em>
            {{ 'cookie.dismiss_text' | translate }}
          </button>

          <button
          [ngClass]="cookieConsent === 'allow' ? 'btn-primary' : 'btn-primary-unselected'"
          [disabled]="cookieConsent === 'allow'"
          (click)="cookieService.set('allow')">
            <em *ngIf="cookieConsent === 'allow'" class="fa fa-check">&nbsp;</em>
            {{ 'cookie.allow_text' | translate }}
          </button>

        </div>
      </div>
    </div>
  </div>

  <div id="contentCookie">
    <ng-container *ngIf="isEnglish">
      <div class="container-fluid">
        <div class="row mt-3 mb-3">
            <div class="col-12 text-center">
                <h1>Kinomap Cookie Policy</h1>
            </div>
        </div>
        <div class="alert alert-warning" role="alert">
            This cookie policy was last updated on March 31, 2021 and applies to citizens of the European Economic Area.
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">1. Introduction</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">
                            Our website https://www.kinomap.com (hereinafter, "the Website") uses cookies and other related technologies (to simplify, all such technologies are referred to as "cookies"). Cookies may also be placed by third parties that we have engaged. In the following document, we inform you about the use of cookies on the Website.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">2. What are cookies?</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">
                            A cookie is a small file stored by a server in the terminal (computer, telephone, etc.) of a user and associated with a web domain (i.e. in most cases with all the pages of a single website). This file is automatically sent back when the user contacts the same domain again.
                        </p>
                        <p class="card-text">Cookies have multiple uses: they can be used to memorize your customer ID with a merchant site, the current contents of your shopping cart, the language in which the web page is displayed, an identifier that allows us to track your navigation for statistical or advertising purposes, etc.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">3. What types of cookies are present on the Website?</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <h4>3.1 Necessary:</h4>
                        <ul>
                            <li>The cookie is used by CDN (Content Delivery Network) services to identify individual clients behind a shared IP address and apply security settings on an individual basis. It does not correspond to any user ID in the web application and does not store any personally identifiable information.</li>
                            <li>The cookie retrieves login information, it is necessary because it is used to maintain the user's login throughout the site (Dashboard, video).</li>
                        </ul>
                        <h4>3.2 Analytics: </h4>
                        <ul>
                            <li>The cookie is installed by Google Analytics. This cookie is used to store information about how visitors use a website and to create an analytical report about the state of that website. The data collected includes the number of visitors, the source from which they came and the pages visited in an anonymous form.</li>
                            <li>The cookie installed by Google Analytics is used to store information about how visitors use a website and to create an analytical report on the state of the website. The data collected includes the number of visitors, the source they came from and the pages visited in an anonymous form.</li>
                        </ul>
                        <h4>3.3 Advertisers:</h4>
                        <ul>
                            <li>The cookie is set by Facebook or other similar platforms to serve advertising when they are on Facebook or a digital platform powered by Facebook advertising after visiting this website.</li>
                            <li>The cookie is set by Facebook to show relevant ads to users and to measure and improve ads. The cookie also tracks user web behavior on sites that have a Facebook pixel or Facebook social plugin.</li>
                            <li>The cookie is set by Facebook to serve ads when they are on Facebook or a digital platform powered by Facebook advertising after visiting the Website.</li>
                            <li>The cookie is used to build a profile based on the user's interests and display personalized ads to users.</li>
                            <li>The cookie is used by Active Campaign for Website tracking purposes.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">4. Consent</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">You may withdraw or change your consent at any time, please contact us at <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">5. Your rights regarding personal data</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">You have the following rights regarding your personal data: </p>
                        <ul>
                            <li><u>Right to be informed:</u> You have the right to know why your personal data is needed, what will happen to it and how long it will be kept.</li>
                            <li><u>Right of access:</u> You have the right to access your personal data that we know about.</li>
                            <li><u>Right to rectification:</u> you have the right at any time to complete, correct, delete or block your personal data.</li>
                            <li>If you have given us your consent to process your data, you have the right to revoke this consent and have your personal data deleted.</li>
                            <li><u>Right to data portability:</u> you have the right to request all your personal data from the controller and to transfer them in their entirety to another controller.</li>
                            <li><u>Right to object:</u> you can object to the processing of your data.</li>
                        </ul>
                        <p class="card-text">To exercise these rights, please contact us at support&#64;kinomap.com. If you have a complaint about the way we process your data, we would like to know about it, but you also have the right to send a complaint with the supervisory authority: data protection authority, such as the European Data Protection Board (EDPB).</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">6. How to manage your cookie settings</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">You can use your web browser to delete cookies automatically or manually. You can also specify that certain cookies cannot be placed. Another option is to change your browser settings in order to receive a message each time a cookie is set. For more information on these options, see the instructions in the Help section of your browser.</p>
                        <p class="card-text">Please note that the Website may not function properly if all cookies are disabled. If you delete the cookies in your browser, they will be placed again with your consent each time you visit the Website.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">7. Contact Information</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">For questions and/or comments about our cookie policy, please contact us using the following contact information:</p>
                        <p class="card-text">
                            KINOMAP<br/>
                            14 rue de la mairie<br/>
                            59500 Douai France<br/>
                            Website : <a href="https://www.kinomap.com">https://www.kinomap.com</a><br/>
                            E-mail : <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a><br/>

                        </p>

                    </div>
                </div>
            </div>
        </div>

    </div>
    </ng-container>

    <ng-container *ngIf="!isEnglish">
      <div class="container-fluid">
        <div class="row mt-3 mb-3">
            <div class="col-12 text-center">
                <h1>Politique de Cookies Kinomap</h1>
            </div>
        </div>
        <div class="alert alert-warning" role="alert">
            Cette politique de cookies a été mise à jour pour la dernière fois le 31 mars 2021 et s’applique aux citoyens de l’Espace Économique Européen.
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">1. Introduction</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">
                            Notre site https://www.kinomap.com (ci-après : « le Site web ») utilise des cookies et autres technologies liées (par simplification, toutes ces technologies sont désignées par le terme « cookies »). Des cookies peuvent être  également placés par des parties tierces que nous avons engagées. Dans le document ci-dessous, nous vous informons de l’utilisation des cookies sur le Site web.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">2. Que sont les cookies ?</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">
                            Un cookie est un petit fichier stocké par un serveur dans le terminal (ordinateur, téléphone, etc.) d’un utilisateur et associé à un domaine web (c’est à dire dans la majorité des cas à l’ensemble des pages d’un même site web). Ce fichier est automatiquement renvoyé lors de contacts ultérieurs avec le même domaine.
                        </p>
                        <p class="card-text">Les cookies ont de multiples usages : ils peuvent servir à mémoriser votre identifiant client auprès d'un site marchand, le contenu courant de votre panier d'achat, la langue d’affichage de la page web, un identifiant permettant de tracer votre navigation à des fins statistiques ou publicitaires, etc. <a href="https://www.cnil.fr/fr/definition/cookie">(cookie CNIL)</a></p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">3. Quels types de cookies sont présents sur le site ?</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <h4>3.1 Nécessaires :</h4>
                        <ul>
                            <li>Le cookie est utilisé par des services CDN (Content Delivery Network) pour identifier les clients individuels derrière une adresse IP partagée et appliquer les paramètres de sécurité sur une base individuelle. Il ne correspond à aucun identifiant d'utilisateur dans l'application Web et ne stocke aucune information personnellement identifiable.</li>
                            <li>Le cookie récupère les informations de connexion, il est nécessaire car il sert à maintenir la connexion de l'utilisateur sur l'ensemble du site (Dashboard, vidéo).</li>
                        </ul>
                        <h4>3.2 Analytiques :</h4>
                        <ul>
                            <li>Le cookie est installé par Google Analytics. Ce cookie est utilisé pour stocker des informations sur la façon dont les visiteurs utilisent un site web et permet de créer un rapport d'analyse sur l'état de ce site web. Les données recueillies comprennent le nombre de visiteurs, la source d'où ils viennent et les pages visitées sous une forme anonyme.</li>
                            <li>Le cookie installé par Google Analytics est utilisé pour stocker des informations sur la façon dont les visiteurs utilisent un site web et permet de créer un rapport d'analyse sur l'état du site web. Les données recueillies comprennent le nombre de visiteurs, la source d'où ils viennent et les pages visitées sous une forme anonyme.</li>
                        </ul>
                        <h4>3.3 Publicitaires :</h4>
                        <ul>
                            <li>Le cookie est défini par Facebook ou d’autres plateformes similaires pour diffuser de la publicité lorsqu'ils se trouvent sur Facebook ou sur une plateforme numérique alimentée par la publicité Facebook après avoir visité ce site web.</li>
                            <li>Le cookie est placé par Facebook pour montrer des publicités pertinentes aux utilisateurs et pour mesurer et améliorer les publicités. Le cookie suit également le comportement de l'utilisateur sur le web sur les sites qui ont un pixel Facebook ou un plugin social Facebook.</li>
                            <li>Le cookie est défini par Facebook pour diffuser de la publicité lorsqu'ils se trouvent sur Facebook ou sur une plateforme numérique alimentée par la publicité Facebook après avoir visité le Site web.</li>
                            <li>Le cookie est utilisé pour établir un profil basé sur les intérêts de l'utilisateur et afficher des publicités personnalisées pour les utilisateurs.</li>
                            <li>Le cookie est utilisé par Active Campaign à des fins de suivi du Site web.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">4. Consentement</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">Vous pouvez retirer ou modifier votre consentement à tout moment, veuillez nous contacter à l’adresse suivante : <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">5. Vos droits concernant les données personnelles</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">Vous avez les droits suivants concernant vos données personnelles <a
                                    href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#:~:text=Rectification%20et%20effacement-,Article%2016%20%2D%20Droit%20de%20rectification,la%20concernant%20qui%20sont%20inexactes. ">(vos droits)</a>:</p>
                        <ul>
                            <li><u>Droit d’information :</u> Vous avez le droit de savoir pourquoi vos données personnelles sont nécessaires, ce qui leur arrivera et combien de temps elles seront conservées.</li>
                            <li><u>Droit d’accès :</u> vous avez le droit d’accéder à vos données personnelles que nous connaissons.</li>
                            <li><u>Droit de rectification :</u> vous avez le droit à tout moment de compléter, corriger, faire supprimer ou bloquer vos données personnelles.</li>
                            <li>Si vous nous donnez votre consentement pour le traitement de vos données, vous avez le droit de révoquer ce consentement et de faire supprimer vos données personnelles.</li>
                            <li><u>Droit de transférer vos données :</u> vous avez le droit de demander toutes vos données personnelles au responsable du traitement et de les transférer dans leur intégralité à un autre responsable du traitement.</li>
                            <li><u>Droit d’opposition :</u> vous pouvez vous opposer au traitement de vos données.</li>
                        </ul>
                        <p class="card-text">Pour exercer ces droits, veuillez nous contacter à l’adresse suivante : <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>. Si vous avez une plainte concernant la façon dont nous traitons vos données, nous aimerions en être informés, mais vous avez également le droit de déposer une plainte auprès de l’autorité de contrôle (l’autorité chargée de la protection des données, comme le Comité européen de la protection des données (CEPD) encore appelé European Data Protection Board (EDPB).</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">6. Activer/désactiver et supprimer les cookies</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">Vous pouvez utiliser votre navigateur internet pour supprimer automatiquement ou manuellement les cookies. Vous pouvez également spécifier que certains cookies ne peuvent pas être placés. Une autre option consiste à modifier les réglages de votre navigateur internet afin que vous receviez un message à chaque fois qu’un cookie est placé. Pour plus d’informations sur ces options, reportez-vous aux instructions de la section Aide de votre navigateur.</p>
                        <p class="card-text">Veuillez noter que le Site web peut ne pas marcher correctement si tous les cookies sont désactivés. Si vous supprimez les cookies dans votre navigateur, ils seront de nouveau placés après votre consentement lorsque vous visiterez de nouveau le Site web.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h2 class="mb-0">7. Coordonnées</h2>
                <div class="card bg-light mb-3">
                    <div class="card-body">
                        <p class="card-text">Pour des questions et/ou des commentaires sur notre politique en matière de cookies et cette déclaration, veuillez nous contacter en utilisant les coordonnées suivantes :</p>
                        <p class="card-text">
                            KINOMAP<br/>
                            14 rue de la mairie<br/>
                            59500 Douai France<br/>
                            Site web : <a href="https://www.kinomap.com">https://www.kinomap.com</a><br/>
                            E-mail : <a href="support@kinomap.com">support&#64;kinomap.com</a><br/>

                        </p>

                    </div>
                </div>
            </div>
        </div>

    </div>
    </ng-container>
  </div>
</div>
